<template>
  <section class="home-landing">
    <div class="hero">
      <div class="overlay">
        <div class="hero-inner">
          <img class="brand" src="/assets/layout/images/wilmar-logo2.png" alt="brand" />
          <h1>Welcome to PAP</h1>
          <p class="lead"><i>Manage Project Documents and Progress—Easier, Faster, Reliable</i></p>
          <div class="cta-group">
            <router-link v-if="listTransactionView.includes('Dashboard')" to="/Dashboard/Index" class="btn primary">Dashboard</router-link>
            <router-link v-if="!isContractor" to="/GeneralInformation/Documentation" class="btn ghost">Documentation</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="features container">
      <div class="feature">
        <h3>Digitized Document</h3>
        <p>Replaces manual process with centralized control</p>
      </div>
      <div class="feature">
        <h3>Automated Workflows</h3>
        <p>Realtime and accurate data updates</p>
      </div>
      <div class="feature">
        <h3>System Integration</h3>
        <p>Eliminate inconsistent data</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  data(){
    return {
      listTransactionView : [],
      isContractor : false,
    }
  },
  mounted() {
    this.listTransactionView =  this.$store.getters.getListTransactionView;
    this.isContractor=  this.$store.getters.getIsContractor;
  },
}
</script>

<style scoped>
.home-landing { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial; color: #222; }
.hero { min-height: 78vh; display:flex; align-items:center; justify-content:center; background-image: url('/assets/layout/images/HomePage.jpg'); background-size: cover; background-position: center; position: relative; }
.hero .overlay { background: rgba(0,0,0,0.45); width:100%; padding: 60px 16px; display:flex; align-items:center; justify-content:center; }
.hero-inner { text-align:center; color: #fff; max-width: 960px; }
.hero-inner .brand { width: 140px; height: auto; margin-bottom: 18px; }
.hero-inner h1 { font-size: 3rem; margin: 0 0 12px; font-weight:700; letter-spacing: -1px; }
.lead { font-size: 1.05rem; margin-bottom: 22px; opacity: 0.95; }
.cta-group { display:flex; gap:12px; justify-content:center; flex-wrap:wrap; }
.btn { display:inline-block; padding: 10px 18px; border-radius: 6px; text-decoration:none; font-weight:600; }
.btn.primary { background: #2a7ae2; color: #fff; }
.btn.ghost { background: rgba(255,255,255,0.12); color: #fff; border: 1px solid rgba(255,255,255,0.18); }
.container { max-width:1100px; margin: 36px auto; padding: 0 16px; }
.features { display:flex; gap: 18px; justify-content:space-between; flex-wrap:wrap; }
.feature { flex:1 1 30%; background:#fff; padding:18px; border-radius:8px; box-shadow: 0 8px 24px rgba(36,37,38,0.06); min-width:220px; }
.feature h3 { margin:0 0 8px; }
.feature p { margin:0; color:#555; }
.lp-footer { border-top:1px solid #eee; padding: 18px 0; margin-top: 30px; text-align:center; color:#666; font-size:0.95rem; }

@media (max-width:768px){
  .hero-inner h1 { font-size: 2rem; }
  .features { flex-direction:column; }
  .feature { flex:1 1 auto; }
}
</style>
